import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'panel-button',
  templateUrl: './panel-button.component.html',
  styleUrls: ['./panel-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PanelButtonComponent {
  @Input() buttonClass?: string[] | string = '';
  @Input() iconClass?: string[] | string = '';
  @Input() icon?: IconProp;

  @Output() buttonClick = new EventEmitter();
}
